import {useSuspenseRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {testIdProps} from '@github-ui/test-id-props'
import {BranchName, RelativeTime} from '@primer/react'

import {repoStackDetailRoute} from '../../routes/repo-stack-detail-route'
import {StackAuthors} from './StackAuthors'
import {StackDetailActions} from './StackDetailActions'
import {StackProgressSummary} from './StackProgressSummary'
import styles from './StackDetailHeader.module.css'
import stacksStyles from './Stacks.module.css'

export function StackDetailHeader() {
  const {data} = useSuspenseRouteQuery(repoStackDetailRoute, 'mainQuery')
  const {stack} = data
  if (!stack) return null
  const pullRequests = stack.size === 1 ? '1 pull request' : `${stack.size} pull requests`

  return (
    <div className={styles.Header} {...testIdProps('stack-detail-header')}>
      <h1 className={styles.Title}>
        Stack <span className={styles.Number}>#{stack.number}</span>
      </h1>
      <div className={styles.Actions}>
        <StackDetailActions />
      </div>
      <div className={styles.Meta}>
        <StackAuthors />
        <span>{pullRequests} targeting </span>
        <BranchName as="span" className={stacksStyles.BranchName}>
          {stack.baseRefName}
        </BranchName>{' '}
        <span aria-hidden="true">&middot;</span> created <RelativeTime date={new Date(stack.createdAt)} />
      </div>
      <StackProgressSummary />
    </div>
  )
}
